import { FaEye } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import { useOrgunitListData } from "./hooks/useOnBoard";
import { useState } from "react";

const OrgListDataColumns = (handleViewClick: (row: any) => void) => [
  {
    name: "Org Unit",
    selector: (row: { UnitName: string }) => row.UnitName || "-",
    sortable: true,
  },
  {
    name: "Action",
    width: "200px",
    cell: (row: any) => (
      <div className="d-flex align-items-center gap-2">
        <button
          className="btn d-flex align-items-center justify-content-center gap-1"
          onClick={() => handleViewClick(row)}
          style={{
            backgroundColor: "#2e8dd3",
            color: "white",
            borderRadius: "20px",
            padding: "3px",
            width: "70px",
            border: "none",
          }}
        >
          <FaEye size={14} style={{ fill: "#fff" }} /> View
        </button>
      </div>
    ),
  },
];

const OnboardingOrgList = () => {
  const navigate = useNavigate();
  const [filterData, setFilterData] = useState({
    search: "",
  });
  const handleViewClick = (row: any) => {
    // console.log("ROW::::::::::::: in terr - OrgList", row);
    navigate(`/onboarding/configuration`, {
      state: { orgunitRowData: row },
    });
  };
  const { data: orgUnitsData, isLoading: orgunitLoading } = useOrgunitListData({
    params: {
      search: filterData.search,
    },
    enable: true,
  });

  //   console.log(
  //     "🚀 ~ OnboardingRequest.tsx:45 ~ OnboardingRequest ~ orgUnitsData:",
  //     orgUnitsData?.data
  //   );

  //   const formattedTableData = Object.entries(orgUnitsData?.data || {}).map(
  //     (item: any, index: any) => ({
  //       OrgunitId: item[0],
  //       OrgunitNames: item[1],
  //     })
  //   );

  return (
    <div className="p-2 mb-5">
      <PageHeader
        title="Onboarding Configuration"
        buttons={
          [
            //   {
            //     label: "Import",
            //     onClick: () => alert("Action 3 clicked"),
            //     color: "#43B9B2",
            //   },
            //   {
            //     label: "Excel",
            //     onClick: () => alert("Action 4 clicked"),
            //     color: "#43B9B2",
            //   },
          ]
        }
      />
      <BasicDataTable
        Title="Org List"
        columns={OrgListDataColumns(handleViewClick)}
        showSpinner={orgunitLoading}
        pagination={false}
        data={orgUnitsData?.data || []}
        handleSearch={(text: any) =>
          setFilterData((prev: any) => ({
            ...prev,
            search: text,
          }))
        }
      />
    </div>
  );
};

export default OnboardingOrgList;
